module.exports = __webpack_public_path__ + "static/media/Palazzo Reale - White - Violet_GrGreen.eb971eed.jpg";